import * as React from "react";

export const XdLogo1Svg = () => (
    <svg
        version="1.1"
        viewBox="0 0 34.5 34"
    >
        <path className="st0"
              d="
        M27.87,27.12
        c3.97-2.18,6.66-6.4,6.66-11.24
        v-3.03
        c0-7.07-5.74-12.82-12.82-12.82
        h-8.9
		C5.74,0.03,0,5.77,0,12.84
		v3.03
		c0,7.08,5.74,12.82,12.82,12.82
		h2.21
		l0,5.28
		L27.87,27.12
		z

		M14.29,21.05
        L12.2,18.41
        L10.2,21.05
        L3.89,21.05
        L9.02,14.32
        L3.89,7.74
        L10.24,7.74
        L12.17,10.19
        L14.02,7.74
        L20.32,7.74
        L15.36,14.28
        L20.63,21.05
        z

        M24.69,16.01c-0.37,0.33-0.98,0.5-1.81,0.5H22.7v-4.24h0.44c1.4,0,2.1,0.7,2.1,2.09
		C25.24,15.13,25.06,15.68,24.69,16.01 M28.75,9.7c-1.27-1.31-3.07-1.96-5.39-1.96h-1.13l-4.96,6.54l5.28,6.77h0.67
		c1.58,0,2.92-0.29,4.03-0.87c1.11-0.58,1.95-1.39,2.53-2.43c0.57-1.05,0.86-2.15,0.86-3.33C30.64,12.58,30.01,11,28.75,9.7
        z
"
              fillRule="evenodd"
              fill="currentColor"
        />
    </svg>
)